module.exports = __webpack_public_path__ + "img/chairliftmilkyway_thumb.e6274828.jpg";